import Cookies from 'js-cookie';

export default {
    data() {
        return {
            cookie_keys: [
                'utm_campaign',
                'utm_medium',
                'utm_source',
                'utm_term',
            ],
            settings: {
                reset: true, // Перезапись куки, если пользователь зашел с другой меткой
            },
            cookie_obj: {},
            cookieValue: {},
        };
    },
    mounted() {
        this.queryForm();
    },
    methods: {
        queryForm() {
            const reset =
                this.settings && this.settings.reset
                    ? this.settings.reset
                    : false;
            const self = window.location.toString();
            const querystring = self.split('?');

            // Сохраняем куки
            if (querystring.length > 1) {
                const pairs = querystring[1].split('&');
                for (let i in pairs) {
                    const keyvalue = pairs[i].split('=');
                    this.cookie_obj[keyvalue[0]] = keyvalue[1];
                    if (
                        reset ||
                        Cookies.get(keyvalue[0]) === null ||
                        Cookies.get(keyvalue[0]) === undefined
                    ) {
                        Cookies.set(
                            keyvalue[0],
                            decodeURIComponent(keyvalue[1]),
                            { expires: 30 }
                        );
                    }
                }
            } else this.checkUtmCookie();
        },
        // Метод, если нужно отправлять в formData
        // cookieUtmToFormData() {
        //     // Создаем объект FormData и добавляем значение из cookie
        //     let formData = new FormData();
        //     Object.entries(this.cookie_obj).forEach(([key, value]) => {
        //         formData.append(key, value);
        //     });
        //     return formData;
        // },
        checkUtmCookie() {
            // Получаем значение из cookie
            this.cookieValue = Cookies.get();

            // Находим пересечение ключей
            let intersection = Object.keys(this.cookieValue).filter((key) =>
                this.cookie_keys.includes(key)
            );

            // Присваиваем cookie_obj найденные ключи из cookie
            intersection.forEach((key, index) => {
                this.cookie_obj[key] = this.cookieValue[key];
            });
        },
    },
};
